import { StyleSheet } from 'aphrodite'
import { Common } from 'styles'

const styles = StyleSheet.create({
  header: {
    backgroundColor: '#fff',
    height: Common.headerHeight,
    borderBottom: `1px solid ${Common.borderColor}`,
    width: '100%'
  },
  headerInner: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    minHeight: Common.headerHeight,
    maxHeight: Common.headerHeight
  },
  logoContainer: {
    order: 0,
    width: Common.treeWidth,
    alignSelf: 'center',

    paddingLeft: '15px'
  },
  logo: {
    cursor: 'pointer',
    height: Common.headerHeight,
    alignItems: 'center',
    display: 'flex'
  },
  headerRole: {
    order: 1,
    width: 'auto',
    overflowX: 'visible',
    WebkitOverflowScrolling: 'touch',
    paddingRight: '20px'
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  systemTab: {
    cursor: 'pointer',
    position: 'absolute',
    background: '#0069b4',
    color: '#fff',
    borderBottomLeftRadius: 6,
    borderBottomRightRadius: 6,
    minWidth: 100,
    width: 'fit-content',
    paddingLeft: '10px',
    paddingRight: '10px',
    fontWeight: 600,
    right: '40px',
    zIndex: 99,
    transition: 'top 0.5s ease-in-out',
    transitionDelay: '.3s',
    ':hover': {
      top: 0
    }
  },
  systemTabItem: {
    paddingTop: 6,
    height: 20,
    textAlign: 'center'
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/Header/styles.js